// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"Styles_checkmark__3AOxy","inner":"Styles_inner__dbwaw"};